export const getOrderBonusStatusText = (prop: string) => {
    switch (prop) {
        case 'PENDING':
            return 'Pendente';
        case 'APPROVED':
            return 'Aprovado';
        case 'DECLINED':
            return 'Reprovado';
        default:
            return 'Pendente';
    }
};